import { createEl } from 'util/create-el';

export const timeStamp = () => {
  const $timeStamp = createEl('div', {
    className: 'c-video__timeStamp',
  });

  return $timeStamp;
};
